package com.speedsoftware.nibbler.ui.boards

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.speedsoftware.nibbler.client.NibblerApiClient
import com.speedsoftware.nibbler.models.ProjectMemberDto
import com.speedsoftware.nibbler.models.TaskDto
import com.speedsoftware.nibbler.models.TaskLogDto
import com.speedsoftware.nibbler.models.UserDto
import com.speedsoftware.nibbler.models.UserRole
import com.speedsoftware.nibbler.ui.components.UserAvatar
import com.speedsoftware.nibbler.ui.components.UserChipContent
import com.speedsoftware.nibbler.ui.components.formatTimestamp
import com.speedsoftware.nibbler.ui.theme.NibblerColors

fun ProjectMemberDto.toUser(): UserDto = UserDto(
    id = userId,
    email = email,
    name = name,
    role = UserRole.USER,
    createdAt = "",
    avatarUrl = avatarUrl,
    avatarEmoji = avatarEmoji
)

/** One line of the activity log: avatar, "<name> <what happened>" and the time. */
@Composable
fun TaskLogRow(log: TaskLogDto) {
    Row(verticalAlignment = Alignment.Top, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        UserAvatar(log.user, 22.dp)
        Column {
            Text(
                text = "${log.user?.name ?: "Deleted user"} ${log.message}",
                fontSize = 12.sp,
                color = NibblerColors.OnSurface
            )
            Text(formatTimestamp(log.createdAt), fontSize = 10.sp, color = NibblerColors.OnSurfaceVariant)
        }
    }
}
